"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var query_string_1 = __importDefault(require("query-string"));
var const_1 = require("remota-common/const");
var Root = function (props) {
    var queries = query_string_1.default.parse(location.search);
    var isHideSidebar = queries[const_1.HIDE_SIDEBAR_QUERY_KEY] === "0";
    if (isHideSidebar) {
        return (react_1.default.createElement(RootPane, null, props.children));
    }
    else {
        return (react_1.default.createElement(RootPane, null,
            react_1.default.createElement(NavPane, null, props.sidebar),
            react_1.default.createElement(MainPane, null, props.children)));
    }
};
exports.Root = Root;
var RootPane = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  height: 100vh;\n  background: ", ";\n\n  box-sizing: border-box;\n\n  font-size: ", ";\n"], ["\n  display: flex;\n\n  height: 100vh;\n  background: ", ";\n\n  box-sizing: border-box;\n\n  font-size: ", ";\n"])), function (props) { return props.theme.colors.background; }, function (props) { return props.theme.standard.fontSize; });
var NavPane = styled_components_1.default.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-shadow: ", ";\n\n  height: 100%;\n  flex: 0 0 200px;\n  background: ", ";\n"], ["\n  box-shadow: ", ";\n\n  height: 100%;\n  flex: 0 0 200px;\n  background: ", ";\n"])), function (props) { return props.theme.standard.boxShadow; }, function (props) { return props.theme.colors.white; });
var MainPane = styled_components_1.default.main(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100%;\n  flex-grow: 1;\n  overflow-y: scroll;\n"], ["\n  height: 100%;\n  flex-grow: 1;\n  overflow-y: scroll;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
